import React from "react";
import { Card } from "react-bootstrap";
import { IconType } from "react-icons";

interface HomePageInfoCardProps {
	icon: IconType;
	title: string;
	text: string;
}

const HomePageInfoCard: React.FC<HomePageInfoCardProps> = ({
	icon: Icon,
	title,
	text,
}) => {
	return (
		<Card className="bg-transparent border-0">
			<Card.Body className="d-flex align-items-start">
				<div className="me-2 fw-bold text-light">
					<Icon size={28} />
				</div>
				<div>
					<Card.Title className="text-primary fw-bold">{title}</Card.Title>
					<Card.Text className="text-light" style={{fontSize: '0.8rem'}}>{text}</Card.Text>
				</div>
			</Card.Body>
		</Card>
	);
};

export default HomePageInfoCard;
